import React from 'react';
import JsonLd from './JsonLd';

/**
 * `.salon-breadcrumb` — fil d'ariane à trois niveaux (spec 3.a).
 *
 * Piège n°15 : le premier niveau de la maquette pointait vers
 * `../homepage-maquette.html`, absent de l'archive. Les cibles réelles sont
 * fournies par l'appelant.
 *
 * Le JSON-LD `BreadcrumbList` est rendu ici même : comme tout le reste, il
 * traverse le rendu serveur et se retrouve donc dans le HTML servi au crawler.
 */
const Breadcrumb = ({ items = [] }) => {
  if (!items.length) return null;

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.label,
      ...(item.href ? { item: item.href } : {}),
    })),
  };

  return (
    <nav className="container salon-breadcrumb" aria-label="Fil d'ariane">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <React.Fragment key={item.label}>
            {index > 0 && (
              <span className="sep" aria-hidden="true">
                /
              </span>
            )}
            {isLast || !item.href ? (
              <span className="current" aria-current="page">
                {item.label}
              </span>
            ) : (
              /* Toujours un <a> : chaque page a son propre état injecté au
                 rendu serveur, une navigation côté client arriverait sur la
                 vue d'en face avec l'état de celle-ci (page blanche). */
              <a href={item.href}>{item.label}</a>
            )}
          </React.Fragment>
        );
      })}
      <JsonLd data={jsonLd} />
    </nav>
  );
};

export default Breadcrumb;
